import {
  Paper,
  TypographyElement,
  Slider,
  MediaQuery,
  Row,
  Icons,
  Icon
} from 'UI'
import { createUseStyles } from 'react-jss'
import styles from './style'
import Text from './text.json'
import { useState, useEffect } from 'react'
import ImagesPopUp from './ImagesPopUp'
import { chunk } from 'lodash'
import { ProfileTypes } from 'constants/'

const useStyle = createUseStyles(styles)
const imagesToShow = 5

const views = (
  view,
  cardStyle,
  image,
  learningPathProjects,
  setSelectedProject,
  setSelectedImage,
  setShowPopUp,
  overlayContainer,
  overlay,
  iconStyle
) => {
  const splicedProjectDetails = chunk(learningPathProjects, 4)
  return splicedProjectDetails.map((item, index) => (
    <div key={index} className={view}>
      {item.map((project, key) =>
        <div key={key} className={cardStyle}>
          <div
            className={overlayContainer}
            onClick={() => {
              setSelectedProject(project)
              setSelectedImage(project.ProjectImages[0])
              setShowPopUp(true)
            }}
          >
            <div className={overlay}>
              <Icon iconName={Icons.magnifyingGlass} style={iconStyle} />
            </div>
            <img
              key={project.CourseId}
              src={project.ProjectImages[0].SmallImageLink}
              alt={`${project.ProjectImages[0].Text} ${project?.Tags?.join(', ')}`}
              height={69}
              width={130}
              className={image}
            />
          </div>
          <TypographyElement
            variant='caption'
          >
            {Text.project} {index * 4 + key + 1}
          </TypographyElement>
        </div>
      )}
    </div>
  ))
}

const responsiveViews = (
  view,
  cardStyle,
  image,
  learningPathProjects,
  setSelectedProject,
  setSelectedImage,
  setShowPopUp,
  overlayContainer,
  overlay,
  iconStyle
) => {
  const splicedProjectDetails = chunk(learningPathProjects, 4)
  return splicedProjectDetails.map((item, index) => (
    <div key={index} className={view}>
      {item.map((project, key) =>
        <div key={key} className={cardStyle}>
          <img
            key={project.CourseId}
            src={project.ProjectImages[0].SmallImageLink}
            alt={project.ProjectImages[0].Text}
            height={69}
            width={130}
            className={image}
            onClick={() => {
              setSelectedProject(project)
              setSelectedImage(project.ProjectImages[0])
              setShowPopUp(true)
            }}
          />
          <TypographyElement
            variant='caption'
          >
            {Text.project} {index * 4 + key + 1}
          </TypographyElement>
        </div>
      )}
    </div>
  ))
}

export default ({
  scrollToPricing,
  projectDescription,
  projectDetails,
  loading,
  margin,
  padding,
  paper,
  isLearningPath,
  learningPathProjects,
  isMobile,
  componentPadding,
  ProfileType,
  courseTitle,
  tags
}) => {
  const {
    paperClass,
    projectSection,
    projectPictures,
    image,
    view,
    cardStyle,
    responsiveCard,
    responsiveRow,
    overlayContainer,
    overlay,
    iconStyle
  } = useStyle({ margin, padding, paper, isLearningPath, isMobile, componentPadding })
  const [showPopUp, setShowPopUp] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)
  const [selectedProject, setSelectedProject] = useState(null)
  const notSubscribedUser = ProfileType ? ProfileType === ProfileTypes.Default || ProfileType === ProfileTypes.Buyer || ProfileType === ProfileTypes.FreeSubscriber : true
  const showPricing = notSubscribedUser
  const title = isLearningPath ? Text.learningPathProjectSectionTitle : Text.courseProjectSectionTitle
  const description = isLearningPath ? Text.learningPathProjectSectionDescription : projectDescription
  const emptyLearningPath = !learningPathProjects?.length && isLearningPath
  const emptyCourse = projectDetails?.length === 0
  useEffect(() => {
    if (showPopUp) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [showPopUp])
  if (emptyLearningPath || emptyCourse || loading) return null
  return (
    <div className={projectSection}>
      <TypographyElement
        variant='heading2'
        Component='h2'
        spacing='0 0 24px 0'
      >
        {title}
      </TypographyElement>
      <Paper className={paperClass}>
        <TypographyElement
          variant='body1'
          spacing='0 0 16px 0'
          dangerouslySetText={description}
        />
        <MediaQuery ShowOnDesktop>
          <div className={projectPictures}>
            {!isLearningPath
              ? projectDetails?.slice(0, imagesToShow)?.map(project => (
                <div
                  onClick={() => {
                    setSelectedImage(project)
                    setShowPopUp(true)
                  }}
                  className={overlayContainer}
                  key={project.Id}
                >
                  <div className={overlay}>
                    <Icon iconName={Icons.magnifyingGlass} style={iconStyle} />
                  </div>
                  <img
                    key={project.ImageId}
                    src={project.SmallImageLink}
                    alt={project.Text + ' ' + tags}
                    height={69}
                    width={120}
                    className={image}
                  />
                </div>
                ))
              : <Slider
                  title={`${learningPathProjects?.length} ${learningPathProjects?.length > 1 ? Text.projects : Text.project}`}
                  views={views(view,
                    cardStyle,
                    image,
                    learningPathProjects,
                    setSelectedProject,
                    setSelectedImage,
                    setShowPopUp,
                    overlayContainer,
                    overlay,
                    iconStyle
                  )}
                  gap={16}
                  titleProps={{
                    variant: 'heading5'
                  }}
                />}
          </div>
        </MediaQuery>
        <MediaQuery HideOnDesktop>
          <Row className={responsiveRow}>
            {
              isLearningPath
                ? responsiveViews(view, cardStyle, image, learningPathProjects, setSelectedProject, setSelectedImage, setShowPopUp)
                : projectDetails?.map(project => (
                  <div key={project.Id} className={responsiveCard}>
                    <img
                      key={project.ImageId}
                      src={project.SmallImageLink}
                      alt={project.Text + ' ' + tags}
                      height={85}
                      width={150}
                      className={image}
                      onClick={() => {
                        setSelectedImage(project)
                        setShowPopUp(true)
                      }}
                    />
                  </div>
                ))
            }
          </Row>
        </MediaQuery>
      </Paper>
      <ImagesPopUp
        projectDetails={projectDetails}
        learningPathProjects={learningPathProjects}
        scrollToPricing={scrollToPricing}
        courseTitle={courseTitle}
        showPricing={showPricing}
        showPopUp={showPopUp}
        setShowPopUp={setShowPopUp}
        selectedImage={selectedImage}
        setSelectedImage={setSelectedImage}
        selectedProject={selectedProject}
        setSelectedProject={setSelectedProject}
        isLearningPath={isLearningPath}
        isMobile={isMobile}
        tags={tags}
      />
    </div>
  )
}
